module.exports = __webpack_public_path__ + "img/TrafficCampaign.821057a.svg";